import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles(theme => ({
  paperRoot: {
    position: 'relative',
    minHeight: '80vh',
    maxHeight: '80vh',
    display: 'flex',
    flexDirection: 'column'
  },
  dialogTitle: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: theme.spacing(1),
    paddingRight: theme.spacing(5)
  },
  headerInfo: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.5)
  },
  closeButton: {
    position: 'absolute',
    top: theme.spacing(1),
    right: theme.spacing(1),
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main,
    '&:hover': {
      color: theme.palette.blue_300.main,
      backgroundColor:
        theme.palette.type === 'dark'
          ? theme.palette.dark_400.main
          : theme.palette.gray_50.main
    }
  },
  avatar: {
    width: 48,
    height: 48
  },
  contactName: {
    fontWeight: 600,
    fontSize: '1rem'
  },
  protocol: {
    fontSize: '0.8rem',
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  },
  dialogContent: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minHeight: 0,
    gap: theme.spacing(1.5)
  },
  searchField: {
    marginTop: theme.spacing(1)
  },
  messagesList: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    padding: theme.spacing(0.5),
    ...theme.scrollbarStyles
  },
  messageItemLeft: {
    alignSelf: 'flex-start',
    maxWidth: '80%',
    backgroundColor:
      theme.palette.type === 'dark'
        ? theme.palette.dark_400.main
        : theme.palette.gray_50.main,
    borderRadius: 8,
    padding: theme.spacing(1)
  },
  messageItemRight: {
    alignSelf: 'flex-end',
    maxWidth: '80%',
    backgroundColor: theme.palette.blue_300.main,
    color: theme.palette.white_100.main,
    borderRadius: 8,
    padding: theme.spacing(1)
  },
  messageMeta: {
    fontSize: '0.7rem',
    opacity: 0.8
  },
  messageBody: {
    fontSize: '0.875rem',
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word'
  },
  emptyText: {
    textAlign: 'center',
    padding: theme.spacing(2),
    color:
      theme.palette.type === 'dark'
        ? theme.palette.dark_50.main
        : theme.palette.gray_400.main
  }
}))
